var React = require('react');

function SliderArrowWhiteInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Design","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd"},React.createElement("g",{"id":"Homepage","transform":"translate(-1355.000000, -184.000000)","fill":"#ffffff"},React.createElement("g",{"id":"Group-4","transform":"translate(1355.000000, 184.000000)"},React.createElement("path",{"d":"M24.84,-4.26325641e-14 L37.52565,12.68496 L37.525719,12.685374 L24.840069,25.371024 L23.864409,24.395364 L34.883,13.375 L-8.02913291e-13,13.375995 L-8.02913291e-13,11.995305 L34.883,11.995 L23.86434,0.97566 L24.84,-4.26325641e-14 Z","id":"Combined-Shape"})))));
}

SliderArrowWhiteInline.defaultProps = {"width":"38px","height":"26px","viewBox":"0 0 38 26","version":"1.1"};

module.exports = SliderArrowWhiteInline;

SliderArrowWhiteInline.default = SliderArrowWhiteInline;
